<template>
    <div>

        <table class="table table-sm table-striped no-margin">
            <thead>
            <tr>
                <th class="col-xs-12 col-sm-4 col-md-6">
                    Item
                </th>
                <th class="col-xs-6 col-sm-4 col-md-3">
                    Price
                </th>
                <th class="col-xs-2 col-sm-4 col-md-3">Quantity</th>
            </tr>
            </thead>
            <tbody class="merchandise__options">
            <tr v-for="(sku, index) in product.skus" :key="index">
                <template v-if="sku.available_inventory > 0">
                    <td class="col-xs-12 col-sm-4 col-md-6 align-middle">
                        {{sku.label}}
                    </td>
                    <td class="col-xs-6 col-sm-4 col-md-3 align-middle">
                        {{sku.price_display}}
                    </td>
                    <td class="col-xs-2 col-sm-2 col-md-3">
                        <div class="input-group mb-0">

                            <plus-minus-control
                                    class="float-right"
                                    :min="0"
                                    :max="maxAllowedQuantity(product, sku)"
                                    v-model="sku.quantity">
                            </plus-minus-control>
                        </div>
                    </td>
                </template>
            </tr>
            </tbody>
        </table>

        <input v-if="showButton"
               type="submit"
               value="Add to basket"
               class="btn btn-ar btn-block btn-success"
               v-on:click="addButton()">

    </div>

</template>

<script>
//See Quantity.vue. Can we merge these two components?
    import PlusMinusControl from './PlusMinsControl.vue'

    export default {
        name: "sku-picker",
        props: {
            productProp: {
                type: Object,
                default: () => ({})
            },
            userProp: {
                type: Object,
                default: null
            },
            participantId: {
                type: String,
                default: null
            },
            showButton: {
                type: Boolean,
                default: true
            },
            theme: {
                type: String,
                default: 'bs3'
            }
        },
        components: {
            PlusMinusControl
        },
        filters: {},
        data() {
            return {
                product: {},
                orderDetails: {},
            }
        },
        created() {
            this.product = this.productProp;
            this.createProductDetails();
        },
        methods: {
            createProductDetails() {
                let object = {
                    user_id: this.userProp !== null ? this.userProp.id : null
                }
                this.orderDetails = object;
            },
            addButton(index) {
                let url = window.location.origin + '/products/' + this.product.slug + '-' + this.product.id + '/order?';
                let validSelection = false; // if at least 1 item has been purchased

                // generate the url
                _.each(this.product.skus, ((sku, index) => {
                        if (sku.quantity > 0) {
                            validSelection = true;
                            url += '&skus[' + index + '][id]=' + sku.id;
                            url += '&skus[' + index + '][quantity]=' + sku.quantity;
                        }
                    })
                );

                if (validSelection) {

                    if (this.userProp !== null) {
                        axios({
                            method: 'POST',
                            url: '/api/v0/orders/bulk',
                            data: {
                                'orderDetails': this.orderDetails,
                                'product': this.product,
                                'pId': this.participantId,
                                'identifier': this.edit ? this.orderProp.identifier : '', // identifier for edit to match existing records
                            },
                        }).then((response) => {
                            url = window.location.origin + '/order-summary'
                            window.location.href = url;

                        })

                    } else {
                        //Existing flow
                        window.location.href = url;
                    }

                } else {
                    alert('Please select at least one item');
                }
            },

            maxAllowedQuantity(product, sku) {
                let maxProductOrderQuantity = product.max_order_quantity;
                let maxSkuOrderQuantity = sku.available_inventory;

                if (maxProductOrderQuantity > 0 && maxProductOrderQuantity < maxSkuOrderQuantity) {
                    return maxProductOrderQuantity;
                } else {
                    return maxSkuOrderQuantity;
                }
            }
        }
    }
</script>
<style lang="scss">
    .align-middle {
        vertical-align: middle !important;
    }
</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/SkuPicker.vue